module.exports = __webpack_public_path__ + "img/2.adeac101.png";